<template>
  <div class="edit-sensor-parameters">
    <input-element
      v-if="sensorData.status && sensorData.status.sdname"
      :title="$t('messages.sensors.sdSetup.sdname')"
      :text="parameters.sdname"
      :disabled="true"
      @change="setValue($event, 'sdname')"
    />
    <select-element
      v-if="sensorData.status && sensorData.status.senstype"
      ref="sensorTypeSelect"
      class="select-element--full"
      :title="$t('messages.sensors.sdSetup.senstype')"
      :value="parameters.senstype"
      :list="types"
      @change="setSenstype($event)"
    />
    <input-element
      v-if="sensorData.status && sensorData.status.description"
      :title="$t('messages.sensors.sdSetup.description')"
      :text="parameters.description"
      @change="setValue($event, 'description')"
    />
    <select-element
      v-if="sensorData.status && sensorData.status.globalsum"
      class="select-element--full"
      :title="$t('messages.sensors.sdSetup.globalsum')"
      :value="Math.abs(parameters.globalsum)"
      :list="computedIncludes"
      @change="setValue(($event.value) * computedSumType, 'globalsum')"
    />
    <select-element
      v-if="sensorData.status && sensorData.status.globalsum"
      class="select-element--full"
      :title="$t('messages.sensors.sdSetup.addsubtract')"
      :value="computedSumType"
      :list="[{value: 1, label: '+'}, {value: -1, label: '-'}]"
      :disabled="parameters.globalsum === 0 || parameters.globalsum === null"
      @change="setValue($event.value * Math.abs(parameters.globalsum), 'globalsum')"
    />
    <select-element
      v-if="sensorData.status && sensorData.status.logtofile"
      class="select-element--full"
      :title="$t('messages.sensors.sdSetup.logtofile')"
      :value="parameters.logtofile"
      :list="monitorTypes"
      @change="setValue($event, 'logtofile')"
    />

    <div
      v-if="sensorData.status && sensorData.status.disable"
      class="edit-sensor__toggle"
      :class="{'active': !parameters.disable}"
    >
      <h4 class="g-title g-title--subtitle">
        {{ $t('messages.sensors.sdSetup.sensorstatus') }}
      </h4>
      <div
        class="g-btn g-btn--rounded g-btn--toggle"
        type="button"
        name="button"
        @click="setValue(!parameters.disable, 'disable')"
      />
      <span>{{ parameters.disable ? $t('messages.sensors.sdSetup.disabled') : $t('messages.sensors.sdSetup.enabled') }}</span>
    </div>

    <div
      v-if="sensorData.status && sensorData.status.display"
      class="edit-sensor__toggle"
      :class="{'active': parameters.display}"
    >
      <h4 class="g-title g-title--subtitle">
        {{ $t('messages.sensors.sdSetup.display') }}
      </h4>
      <div
        class="g-btn g-btn--rounded g-btn--toggle"
        type="button"
        name="button"
        @click="setValue(!parameters.display, 'display')"
      />
      <span>{{ parameters.display ? $t('messages.sensors.sdSetup.displayon') : $t('messages.sensors.sdSetup.displayoff') }}</span>
    </div>
    
    <div
      v-if="sensorData.status && sensorData.status.consump"
      class="edit-sensor__toggle"
      :class="{'active': parameters.consump}"
    >
      <h4 class="g-title g-title--subtitle">
        {{ $t('messages.sensors.sdSetup.consump') }}
      </h4>
      <div
        class="g-btn g-btn--rounded g-btn--toggle"
        type="button"
        name="button"
        @click="setValue(!parameters.consump, 'consump')"
      />
      <span>{{ parameters.consump ? $t('messages.sensors.sdSetup.usageon') : $t('messages.sensors.sdSetup.usageon') }}</span>
    </div>

    <div v-if="sensorData.relations.length">
      <h4 class="g-title g-title--subtitle">
        {{ $t('messages.sensors.sdSetup.linked') }}
      </h4>
      <div class="edit-sensor-parameters__options">
        <div class="edit-sensor-parameters__options__row">
          <div
            v-for="key in computedRelationKeys"
            :key="key"
          >
            <h6>{{ key }}</h6>
          </div>
        </div>

        <div
          v-for="relation in sensorData.relations"
          :key="relation.sdname"
          class="edit-sensor-parameters__options__row"
        >
          <span>{{ relation.sdname }}</span>
          <span>{{ Math.sign(relation.globalsum) > 0 ? '+' : '-' }}</span>
          <span>{{ relation.description }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import{MicroService} from'@/assets/javascript/mixins/Mixins'
import InputElement from'@/components/elements/InputElement.vue'
import SelectElement from'@/components/elements/SelectElementReactive.vue'
import {convertToOptions} from '@/assets/javascript/utilities'

export default {
  name: 'EditSensorDecoderParameters',
  components: {
    'input-element': InputElement,
    'select-element': SelectElement
  },
  mixins: [SocketHandler, LifeCycle, MicroService],
  props: {
    PageMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    blankSensor: {
      type: Object,
      default() {
        return {}
      }
    },
    sensorData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    store: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      types: [],
      monitorTypes: [],
      includes: []
    }
  },
  computed: {
    computedRelationKeys() {
      return this.sensorData.relations && this.sensorData.relations.length
      ? Object.keys(this.sensorData.relations[0]).map(key => this.$t(`messages.sensors.sdSetup.${key}`))
      : []
    },
    parameters() {
      return this.sensorData ? this.sensorData.data : {}
    },
    relations() {
      return this.sensorData
      ? this.sensorData.relations.slice().sort().map((relation, indx) => ({
        value: indx,
        label: relation,
        disabled: true
      }))
      : []
    },
    computedIncludes() {
      return [{label: 'Not Included', value: 0}, ...this.includes]
    },
    computedSumType() {
      return this.parameters.globalsum
      ? Math.sign(this.parameters.globalsum)
      : 1
    },
    computedCtrlID() {
      return this.store.getData('controller.deviceData.ctrlid')
    },
    computedSensorType() {
      return this.parameters.senstype
    }
  },
  watch: {
    PageMessage(msg) {
      if(msg && (msg.target === 'sensor-decoder-parameters-change' || msg.target === 'sensor-decoder-parameters-cancel')) {
        msg.choice === 'change'
        ? this.setValue(msg.data.new, 'senstype')
        : this.$refs.sensorTypeSelect.reset()
      }
    },
    computedSensorType: {
      handler(newVal, oldVal) {
        this.getMonitor(newVal)
        this.getIncludes(newVal)
      },
      immediate: true
    }
  },
  mounted() {
    this.getTypes()
  },
  methods: {
    setSenstype(type) {
      this.$emit('SetPageMessage', {
        target: 'ShowModal',
        modalData: {
          component: 'DialogueModal',
          data: {
            title: 'Please Notice',
            prefix: 'sensor-decoder-parameters-',
            text: 'Changing Sensor type will clear all settings for the sensor including alarms and actions.',
            data: {
              new: type.value,
              old: this.parameters.senstype
            },
            options: [
              {label: 'Change', value: 'change'}, {label: 'Cancel', value: 'cancel'}
            ]
          }
        }
      })
    },
    deleteSensor(data) {
      this.$emit('SetPageMessage', {
        target: 'sensors',
        command: 'delete',
        data
      })
      
      this.$nextTick(() => {
        this.$emit('CloseModal')
      })
    },
    updateSensor(data) {
      this.sendMicroServiceRequest({
        method: 'POST',
        url: `api/authenticated/function/updatesdsetup?ctrlid=${this.computedCtrlID}`,
        data
      })
      .then((response) => {
        if(response && response.data && response.data.updatesdsetup) {
          if(this.parameters.senstype !== response.data.updatesdsetup[0].data.senstype) {
            let sensorType = (this.types.find(type =>
              type.value === data.senstype)
            ).label

            this.$emit('SetPageMessage', {
              target: 'ShowModal',
              modalData: {
                component: 'DialogueModal',
                data: {
                  title: 'Warning',
                  prefix: 'sensor-decoder-parameters-warning-',
                  text: `The maximum amount of type ${sensorType} has been reached.`,
                  options: [{label: 'OK', value: 'ok'}]
                }
              }
            })
          }
          Object.assign(this.sensorData, response.data.updatesdsetup[0])
        }
        let Msg = { category: 'server', command: 'synchronize', data: { 'type': 'initiate' } }
        this.SocketMessageSend( Msg )

        if(response.status !== 200)
          console.error(response)
      })
      .catch(console.error)
    },
    getTypes() {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdsetupdropdown?language_code=en-US`
      })
      .then((response) => {
        response.data
        ? this.$set(this, 'types', convertToOptions(response.data.getsdsetupdropdown, 'enum', 'lang'))
        : console.error('no data for getsdsetupdropdown')
      }).catch(console.error)
    },
    getMonitor(flowType) {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdsetupsecondarydropdown?ctrlid=${this.computedCtrlID}&enum=${flowType}&language_code=en-US`
      })
      .then((response) => {
        response.data
        ? this.$set(this, 'monitorTypes', convertToOptions(response.data.getsdsetupsecondarydropdown, 'enum', 'lang'))
        : console.error('no data for getsdsetupsecondarydropdown')
      }).catch(console.error)
    },
    getIncludes(flowType) {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getsdrecordrelations?ctrlid=${this.computedCtrlID}&senstype=${flowType}`
      })
      .then((response) => {
        response.data
        ? this.$set(this, 'includes', convertToOptions(response.data.getsdrecordrelations, 'relation', 'sdname'))
        : console.error('no data for getsdrecordrelations')
      }).catch(console.error)
    },
    setValue(option, name) {
      const value = option.value !== undefined ? option.value : option
      this.$set(this.parameters, name, value)
      this.updateSensor(Object.assign({}, this.blankSensor, this.parameters))
    }
  }
}
</script>
<style lang="scss">
.edit-sensor-parameters {
  &__options {
    top: calc(100% - 1px);
    box-shadow: none;
    font-size: 11px;
    text-align: center;

    h6 {
      font-size: 9px;
      margin: 0;
    }
    &__row {
      box-sizing: border-box;
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 2fr 3fr;
      margin: 0;
      border: 1px solid $color-grey;
      border-bottom: 0;
      border-right: 0;
      &:not(:first-child) {
        border-top: 0;
      }

      > * {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 5px;
        border: 1px solid $color-grey;
        border-top: 0;
        border-left: 0;
        margin-right: -1px;
        margin-bottom: -1px;
      }
    }
  }
}
</style>
